import script from "./ModalCartAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCartAlert.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCartAlert.vue?vue&type=style&index=0&id=7c65f49e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c65f49e"]])

export default __exports__